import i18n from './i18n';

export const FlashDefinition = {
  credentialsValidationSuccess: {
    context: [{ detail: i18n.credentialsValidationSuccess }],
    status: 'success',
  },
  integrationUpdateError: {
    context: [{ detail: i18n.integrationUpdateError }],
    status: 'error',
  },
  invalidCredentials: {
    context: [{ detail: i18n.invalidCredentials }],
    status: 'error',
  },
  invalidCorporationId: ({ expected: currentId, received: receivedId }) => ({
    context: [
      { detail: i18n.invalidCorporationId, values: { currentId, receivedId } },
    ],
    status: 'error',
  }),
  invalidFileError: {
    context: [{ detail: i18n.errorInvalidFile }],
    status: 'error',
  },
  deployMetadataError: {
    context: [{ detail: i18n.deployMetadataError }],
    status: 'error',
  },
};
